export const withLists = (editor) => {
  // The code that used to be here was moved to the basic SlateEditor normalizeNode
  // In the future, custom behavior for normalizeNode should be added here
  return editor;
};
